import AssetSvc from '@/services/AssetSvc';

// Dua pemanggil minta payload yang sama persis pas boot; yang barengan disatuin.
let inFlight = null;

export default async function getScopedAssets() {
  if (!inFlight) {
    inFlight = AssetSvc.getAssets({ params: { page: 1, max: 1000 } })
      .then((res) => res.data?.data || [])
      .finally(() => { inFlight = null; });
  }
  return inFlight;
}
